<div class="wrapper">
  <div class="times">
    <span id="hours"></span>
    <span>:</span>
    <span id="mins"></span>
    <span>:</span>
    <span id="seconds"></span>
  </div>
</div>